export const environment = {
  production: false,
  
  // Base URLs des APIs backend
  apiBaseUrl: 'https://back.s-o-p.org/api/v1',
  fileConverterBaseUrl: 'https://fileconverter.s-o-p.org',
  fileConverterDownloadUrl: '/api/files/pdf/convert/download/',
  
  // Adresse du support
  supportEmail: 'support@convertir-fichier.com',
  
  // Endpoints des APIs
  apiEndpoints: {
    // Endpoints pour la gestion des fichiers PDF (via fileconverter.s-o-p.org)
    pdf: {
      upload: '/upload',
      convert: '/convert',
      download: '/download',
      status: '/status',
      list: '/list',
      delete: '/delete'
    },
    
    // Endpoints pour la gestion des leads
    leads: {
      create: '/leads'
    },

    // Endpoints pour la gestion des prospects
    prospects: {
      create: '/prospects'
    },
    
    // Endpoints pour la gestion des paiements
    payments: {
      createIntent: '/payments/create-intent',
      confirm: '/payments/confirm',
      updateProspect: '/prospects/:id/payment'
    },
    
    // Endpoints pour la gestion des transactions
    transactions: {
      create: '/transactions'
    },
    
    // Endpoints pour la gestion des erreurs et logs
    system: {
      health: '/health',
      logs: '/logs',
      errors: '/errors'
    }
  },
  
  // Configuration des timeouts
  timeouts: {
    request: 30000, // 30 secondes
    upload: 300000, // 5 minutes
    conversion: 600000 // 10 minutes
  },
};